const api_info = {};
// frontend_endpoint,
// backend_endpoint,
// token,
// username,

async function frontEndPost(context, path, body) {
    const { frontend_endpoint, username, token } = context;
    const response = await fetch(`${frontend_endpoint}${path}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    });
    return response.json();
}

async function submitDraftRequest(context, body) {
    return frontEndPost(context, '/submit_draft_request', body);
}

async function getDraftRequest(context, body) {
    return frontEndPost(context, '/get_draft_request', body);
}

async function listOrganization(context, body) {
    return frontEndPost(context, '/list_organization', body);
}

async function submitApproveRequest(context, body) {
    return frontEndPost(context, '/submit_approve_request', body);
}

async function fetchWithAuthentication(context, path, body) {
    const { backend_endpoint, username, token } = context;
    const response = await fetch(`${backend_endpoint}${path}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            ...body,
            token,
        }),
    });
    return response.json();
}

export {
    api_info,
    fetchWithAuthentication,
    submitDraftRequest,
    getDraftRequest,
    listOrganization,
    submitApproveRequest,
};
